import { createTypes } from 'redux-action-creator'
export const types = createTypes(['SET_PROJECT'])

export const setProject = (values) =>
  ({
    type: types.SET_PROJECT,
    payload: values
  })
